export default "__VITE_ASSET__c328a90f__"